export default "__VITE_ASSET__B0Jas2Jm__"